export enum DynamicFieldType {
  TEXT = 'TEXT',
  DROPDOWN = 'DROPDOWN',
  DROPDOWN_EXTERNAL = 'DROPDOWN_EXTERNAL',
}

export class ScopeDynamicFieldSettingModel {
  id: number
  name: string
  displayName: string
  type: DynamicFieldType
  mandatory: boolean
  value?: string
  jsonValueName?: string
  defaultValue: string
  companyApiIntegrationId?: number
  externalSystemResourceUri?: string
  fetchFirstPageOnly = true
  apiIntegrationName?: string
}

export class DeliverableDynamicFieldSettingModel extends ScopeDynamicFieldSettingModel {}
